import { Alert } from "@mui/material";
import { ConnectionResult } from "./ConnectionResult";

type Props = {
  connectionResult: ConnectionResult;
};

const CANT_READ_ERROR_MESSAGE = "Vous n'avez pas accès à ce module";
const INVALID_LOGIN_ERROR_MESSAGE = "La connexion a échoué, réessayer!";

const ConnectionErrorMessage: React.FC<Props> = ({ connectionResult }) => {
  let errorMessage;
  if (connectionResult == ConnectionResult.CANT_READ) {
    errorMessage = CANT_READ_ERROR_MESSAGE;
  } else {
    errorMessage = INVALID_LOGIN_ERROR_MESSAGE;
  }

  return (
    <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
      {errorMessage}
    </Alert>
  );
};

export default ConnectionErrorMessage;
